module.exports = __webpack_public_path__ + "static/cuttlery-c1a91fed6309a5349ce0db94a0d51cc0.png";